<template>
  <div>
    <v-dialog
      v-model="dialog_preview_setting"
      scrollable
      persistent
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title style="background-color:rgba(227, 236, 238, 0.9);">
          ตั้งค่าหน้าปก
          <v-spacer></v-spacer>
          <v-btn icon class="float-right" @click="dialog_preview_setting = false">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-card class="pt-2 my-3 mt-6" outlined>
            <v-card-title class="justify-center main-title pb-0">หน้าปกทั้งหมด</v-card-title>
            <!-- <pre>{{preview_list}}</pre> -->

            <v-data-table :headers="preview_headers" :items="preview_list">
              <template v-slot:top>
                <v-col align="right">
                  <v-btn
                    @click="openPreviewSetting('create', null)"
                    color="primary"
                    dark
                    class="btn-responsive"
                  >
                    <v-icon class="mr-2">mdi-plus-circle</v-icon>เพิ่มหน้าปก
                  </v-btn>
                </v-col>
              </template>
              <!-- detail in dataTable -->
              <template v-slot:item.no="{ item }">{{ preview_list.indexOf(item) + 1 }}.</template>
              <template v-slot:item.picturefile="{ item }">
                <v-img
                  :src="
                    item.image_cover_file_path
                      ? env + item.image_cover_file_path
                      : ''
                  "
                  aspect-ratio="1"
                  max-width="120px"
                ></v-img>
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn icon @click="openPreviewSetting('edit', item)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon @click="deleteImage(item.image_cover_file_id)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
            <v-btn
              class="ma-2 d-block d-sm-none"
              fab
              color="secondary"
              bottom
              dark
              fixed
              right
              @click="dialog = !dialog"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- dialog -->
    <v-dialog v-model="dialog" max-width="900px" persistent content-class="alldialog_settings">
      <v-card class>
        <v-card-title primary-title style="background-color:rgba(227, 236, 238, 0.9);">เพิ่มหน้าปก</v-card-title>
        <span v-if="file_image_from_api" class="ma-4">
          <v-card class="mx-10">
            <v-card-title class="py-0 pt-1">
              <v-spacer></v-spacer>
              <v-btn icon @click="removeOldPicture()">
                <v-icon class="float-right">mdi-window-close</v-icon>
              </v-btn>
            </v-card-title>
            <!-- <pre>{{env+file_image_from_api}}</pre> -->
            <img class="ml-2 my-2" :src="env + file_image_from_api" width="790px" />
          </v-card>
        </span>
        <span v-else>
          <v-row align="center" justify="center" class="mx-0">
            <v-col cols="6" class="mx-0">
              <v-card
                v-if="show_img"
                class="text-center pa-1"
                height="120"
                outlined
                style="border:1px solid rgba(0, 0, 0, 0.38);"
              >
                <label :for="namephotofile">
                  <center>
                    <v-icon class="float-center pt-4">mdi-cloud-upload</v-icon>
                  </center>
                  <p class="pt-5 px-3 py-1 text-center">อัปโหลดรูปภาพ</p>
                </label>
              </v-card>
              <p
                v-if="file_image_from_api==''||file_image==''"
                style="color:red; font-size:12px;"
              >* กรุณาใส่รูปภาพ</p>
            </v-col>
          </v-row>
          <v-card v-show="!show_img" class="mx-10">
            <v-card-title class="py-0 pt-1">
              <v-spacer></v-spacer>
              <v-btn icon @click="removeImage()">
                <v-icon class="float-right">mdi-window-close</v-icon>
              </v-btn>
            </v-card-title>
            <img
              class="ml-2 my-2"
              v-for="(img, i) in file_image"
              :key="i"
              :src="img ? img.thumb : ''"
              width="790px"
            />
          </v-card>

          <file-upload
            class="btn btn-primary dropdown-toggle"
            input-id="photofile"
            :directory="directory"
            :accept="acceptphoto"
            :extensions="extensionsphoto"
            :size="size || 0"
            :thread="thread < 1 ? 1 : thread > 5 ? 5 : thread"
            :headers="headers"
            :data="data"
            @input-filter="inputFilter"
            v-model="file_image"
            @input-file="inputFile"
            ref="preview_media"
          ></file-upload>
        </span>
        <!-- DESCRIPTION -->
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <h3>
                เนื้อหากล่องที่ 1
                <v-divider class="ml-3"></v-divider>
              </h3>
            </v-col>
            <v-col cols="6">
              <h3>
                เนื้อหากล่องที่ 2
                <v-divider class="ml-3"></v-divider>
              </h3>
            </v-col>
          </v-row>
          <v-form ref="description_form">
            <v-row>
              <v-col cols="5">
                <v-text-field v-model="topic1" dense label="หัวข้อ" outlined :rules="is_empty"></v-text-field>
                <v-text-field
                  v-model="description1"
                  dense
                  label="วันที่เปิดทำการ"
                  outlined
                  :rules="is_empty"
                ></v-text-field>
                <v-text-field
                  v-model="description1_1"
                  dense
                  label="เวลาที่เปิดทำการ"
                  outlined
                  :rules="is_empty"
                ></v-text-field>
                <v-text-field
                  v-model="description1_2"
                  dense
                  label="ผู้ดูแล"
                  outlined
                  :rules="is_empty"
                ></v-text-field>
                <v-autocomplete
                  v-model="link_path1"
                  label="หน่วยงาน"
                  :items="all_subunit_category"
                  item-text="sub_unit_category_name"
                  item-value="sub_unit_category_id"
                  outlined
                  :rules="is_empty"
                  dense
                ></v-autocomplete>
                <!-- <v-text-field v-model="link_path1" dense label="Subunit" outlined :rules="is_empty"></v-text-field> -->
              </v-col>
              <v-col cols="2" align="center">
                <v-divider vertical></v-divider>
              </v-col>
              <v-col cols="5">
                <v-text-field v-model="topic2" dense label="หัวข้อ" outlined :rules="is_empty"></v-text-field>
                <v-text-field
                  v-model="description2"
                  dense
                  label="วันที่เปิดทำการ"
                  outlined
                  :rules="is_empty"
                ></v-text-field>
                <v-text-field
                  v-model="description2_1"
                  dense
                  label="เวลาที่เปิดทำการ"
                  outlined
                  :rules="is_empty"
                ></v-text-field>
                <v-text-field
                  v-model="description2_2"
                  dense
                  label="ผู้ดูแล"
                  outlined
                  :rules="is_empty"
                ></v-text-field>
                <v-autocomplete
                  v-model="link_path2"
                  label="หน่วยงาน"
                  :items="all_subunit_category"
                  item-text="sub_unit_category_name"
                  item-value="sub_unit_category_id"
                  outlined
                  :rules="is_empty"
                  dense
                ></v-autocomplete>

                <!-- <v-text-field v-model="link_path2" dense label="Subunit" outlined :rules="is_empty"></v-text-field> -->
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="close">ยกเลิก</v-btn>
          <v-btn color="primary" type="submit" :loading="click" @click="save()" text>บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import FileUpload from "vue-upload-component";
export default {
  components: {
    FileUpload,
  },
  data() {
    return {
      click: false,
      env: process.env.VUE_APP_API,
      mode: "",
      show_img: true,
      dialog_preview_setting: false,
      header_token: {
        headers: { Authorization: "Bearer " + this.$session.get("token") },
      },
      dialog: false,
      preview_headers: [
        {
          text: "ลำดับ",
          value: "no",
          sortable: false,
          align: "center",
          width: "20%",
        },
        {
          text: "รูปภาพ",
          value: "picturefile",
          sortable: false,
          align: "left",
          width: "60%",
        },
        {
          text: "จัดการ",
          value: "action",
          sortable: false,
          align: "center",
          width: "20%",
        },
      ],
      preview_list: [],
      minSize: 1024,
      size: 1024 * 1024 * 10,
      acceptphoto: "image/png,image/gif,image/jpeg,image/jpg", //,video/mp4,video/x-m4v,video/*
      extensionsphoto: "gif,jpg,jpeg,png",
      directory: false,
      thread: 3,
      postAction: "/upload/post",
      headers: {
        "X-Csrf-Token": "xxxx",
      },
      data: {
        _csrf_token: "xxxxxx",
      },
      autoCompress: 1024 * 1024,
      uploadAuto: true,
      namephotofile: "photofile",
      file_image: [],
      // img id
      edit_id: 0,
      // content
      topic1: "",
      topic2: "",
      description1: "",
      description1_1: "",
      description1_2: "",
      description2: "",
      description2_1: "",
      description2_2: "",
      link_path1: "",
      link_path2: "",
      file_image_from_api: null,
      // rules
      is_empty: [
        (v) => !!v || "** กรุณากรอกข้อมูล",
        (v) => (!!v ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      ],
      all_subunit_category: [],
    };
  },
  watch: {},
  created() {
    this.getPreview();
    this.getSubunitCategory();
  },
  methods: {
    getSubunitCategory() {
      let subunit_category = [];
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/subunitcategory")
        .then((response) => {
          subunit_category = response.data;
          this.all_subunit_category = subunit_category;
        });
    },
    removeOldPicture() {
      this.file_image_from_api = null;
    },
    openSetting() {
      this.dialog_preview_setting = true;
      this.show_img = true;
    },
    openPreviewSetting(mode, item) {
      // console.log(item);
      this.mode = mode;
      this.dialog = true;
      if (this.mode == "create") {
        this.file_image = [];
        this.file_image_from_api = "";
        setTimeout(() => {
          this.$refs.description_form.reset();
          this.$refs.description_form.resetValidation();
          this.edit_id = 0;
        }, 100);
      } else if (this.mode == "edit") {
        this.edit_id = item.image_cover_file_id;
        this.topic1 = item.topic1;
        this.topic2 = item.topic2;
        this.description1 = item.description1;
        this.description1_1 = item.description1_1;
        this.description1_2 = item.description1_2;
        this.description2 = item.description2;
        this.description2_1 = item.description2_1;
        this.description2_2 = item.description2_2;
        this.link_path1 = parseInt(item.link1);
        this.link_path2 = parseInt(item.link2);
        this.file_image_from_api = item.image_cover_file_path;
      }
    },
    inputFile(newFile) {},
    inputFilter(newFile, oldFile, prevent) {
      this.show_img = false;
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
    },
    getPreview() {
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/image_cover/")
        .then((response) => {
          let preview = [];
          // console.log(response.data);
          preview = response.data;
          this.preview_list = preview;
          this.$store.state.preview_img = preview;
        });
    },
    postPreview() {
      // console.log(this.mode);
      // console.log(this.file_image);
      let form = new FormData();
      let data = {
        topic1: this.topic1,
        topic2: this.topic2,
        description1: this.description1,
        description1_1: this.description1_1,
        description1_2: this.description1_2,
        description2: this.description2,
        description2_1: this.description2_1,
        description2_2: this.description2_2,
        link1: this.link_path1,
        link2: this.link_path2,
      };
      if (this.$refs.description_form.validate()) {
        if (this.mode == "create") {
          if (
            this.file_image.length != 0 &&
            this.$refs.preview_media.files != ""
          ) {
            for (let i = 0; i < this.file_image.length; i++) {
              form = new FormData();
              form.append("file", this.file_image[i].file);
              this.axios
                .post(
                  process.env.VUE_APP_API + "/api/v1/image_cover/",
                  form,
                  this.header_token
                )
                .then((response) => {
                  // console.log(response.data);
                  let id = response.data;
                  this.axios
                    .post(
                      process.env.VUE_APP_API +
                        "/api/v1/image_cover/" +
                        id +
                        "/description",
                      data,
                      this.header_token
                    )
                    .then((response) => {
                      if (response.data == "create success") {
                        this.$swal.fire({
                          icon: "success",
                          title: "เพิ่มรูปภาพสำเร็จ",
                          showConfirmButton: false,
                          timer: 1000,
                        });
                        this.click = false;
                        this.getPreview();
                      }
                    });
                  form = new FormData();
                });
            }
          }
        } else if (this.mode == "edit") {
          if (this.file_image_from_api) {
            // old img
            // console.log("edit with old img");
            this.axios
              .post(
                process.env.VUE_APP_API +
                  "/api/v1/image_cover/" +
                  this.edit_id +
                  "/description",
                data,
                this.header_token
              )
              .then((response) => {
                if (response.data == "create success") {
                  this.$swal.fire({
                    icon: "success",
                    title: "แก้ไขข้อมูลสำเร็จ",
                    showConfirmButton: false,
                    timer: 1000,
                  });
                  this.getPreview();
                }
              });
          } else if (this.file_image.length > 0) {
            // remove && add new img
            this.axios
              .delete(
                process.env.VUE_APP_API + "/api/v1/image_cover/" + this.edit_id,
                this.header_token
              )
              .then((response) => {
                // console.log(response.data);
                if (response.data == "success") {
                  // console.log("delete success");
                }
              });
            for (let i = 0; i < this.file_image.length; i++) {
              form = new FormData();
              form.append("file", this.file_image[i].file);
              this.axios
                .post(
                  process.env.VUE_APP_API + "/api/v1/image_cover/",
                  form,
                  this.header_token
                )
                .then((response) => {
                  // console.log("create new");
                  // console.log(response.data);
                  let id = response.data;
                  this.axios
                    .post(
                      process.env.VUE_APP_API +
                        "/api/v1/image_cover/" +
                        id +
                        "/description",
                      data,
                      this.header_token
                    )
                    .then((response) => {
                      if (response.data == "create success") {
                        this.$swal.fire({
                          icon: "success",
                          title: "แก้ไขรูปภาพสำเร็จ",
                          showConfirmButton: false,
                          timer: 1000,
                        });
                        this.getPreview();
                      }
                    });
                  form = new FormData();
                });
            }
          }
        }
      }
    },
    close() {
      this.click = false;

      this.file_image[0]
        ? this.$refs.preview_media.remove(this.file_image[0])
        : "";
      this.file_image = [];
      this.show_img = true;
      this.dialog = false;
      // this.clear();
    },
    removeImage() {
      this.$refs.preview_media.remove(this.file_image[0]);
      this.show_img = true;
    },
    deleteImage(id) {
      this.$swal
        .fire({
          title: "ต้องการลบรายการนี้ใช่หรือไม่?",
          text: "ข้อมูลจะถูกลบทันทีเมื่อกด 'ยืนยัน' ยกเลิกรายการกด 'ยกเลิก'",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#E53935",
          cancelButtonColor: "#9E9E9E",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        })
        .then((res) => {
          if (res.value) {
            this.axios
              .delete(
                process.env.VUE_APP_API + "/api/v1/image_cover/" + id,
                this.header_token
              )
              .then((response) => {
                this.$swal.fire({
                  icon: "success",
                  title: "ลบข้อมูลสำเร็จ",
                  showConfirmButton: false,
                  timer: 1000,
                });
                this.getPreview();
              });
          }
        });
      // this.file_image_from_api.splice(index, 1);
    },
    save() {
      if (
        this.$refs.description_form.validate() &&
        (this.file_image.length > 0 || this.file_image_from_api)
      ) {
        this.click = true;
        this.postPreview();
        this.close();
      } else {
        this.$swal.fire({
          icon: "warning",
          title: "ข้อมูลไม่สมบูรณ์",
          text: "กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง",
          showConfirmButton: false,
          timer: 1000,
        });
      }
    },
  },
};
</script>
